const constants = {
  role: {
    ADMIN: 'Admin',
    RNO: 'RNO',
  },
};

export default constants;
